import formatPrice from '../../formatPrice';

export default {
    mixins: [formatPrice],
    data() {
        return {
            totalPrice: 0,
        }
    },
    methods: {

        calculeTotalAmount(plans, needCheck = true) {
            let totalAmount = 0;
            let tableItems = [];

            // plans
            for (let i = 0; i < plans.length; i++) {
                const plan = plans[i];

                // unit
                if (plan.type === 'unit') {
                    if (plan.checked || ! needCheck) {
                        totalAmount += plan.price;
                    }
                }

                // volume
                if (plan.type === 'volume') {
                    if (plan.quantity || ! needCheck) {
                        let priceUnit = plan.overage_price

                        let priceOption = this.getPriceOption(plan.options, plan.quantity);
                        if (priceOption) {
                            priceUnit = priceOption.price;
                        }

                        let amount = plan.quantity * priceUnit;

                        totalAmount += amount;
                    }
                }
            }

            return totalAmount;
        },

        calculeResume(plans, needCheck = true) {
            let totalAmount = 0;
            let tableItems = [];

            // plans
            for (let i = 0; i < plans.length; i++) {
                const plan = plans[i];

                // unit
                if (plan.type === 'unit') {
                    if (plan.checked || ! needCheck) {
                        totalAmount += plan.price;

                        tableItems.push({
                            item: plan.name,
                            quantidade: 1,
                            valor_unitario: this.formatPrice(plan.price),
                            total: this.formatPrice(plan.price)
                        });
                    }
                }

                // volume
                if (plan.type === 'volume') {
                    if (plan.quantity || ! needCheck) {
                        let priceUnit = plan.overage_price

                        let priceOption = this.getPriceOption(plan.options, plan.quantity);
                        if (priceOption) {
                            priceUnit = priceOption.price;
                        }

                        let amount = plan.quantity * priceUnit;

                        totalAmount += amount;

                        tableItems.push({
                            item: plan.name,
                            //plano: priceOption.name,
                            quantidade: plan.quantity,
                            valor_unitario: this.formatPrice(priceUnit),
                            total: this.formatPrice(amount)
                        });
                    }
                }
            }

            tableItems.push({
                item: '',
                quantidade: '',
                valor_unitario: '',
                total: this.formatPrice(totalAmount) + ' / mês',
                _cellVariants: { total: 'info' }
            });

            this.totalPrice = this.formatPrice(totalAmount);

            return tableItems;
        },

        getPriceOption(options, quantity) {
            for (let i = 0; i < options.length; i++) {
                const option = options[i];

                if (quantity >= option.start_quantity && quantity <= option.end_quantity) {
                    return option;
                }
            }

            return false;
        }
    }
}
